// @ts-check
import { Engine, Component } from "../engine";
import {
    LOGIC_GAME_POST,
    GAMETYPE_TIME,
    GAMETYPE_BOMB,
    EVENT_INGAME_TROPHY_ACHIEVED,
    ENTITY_STATE_DEFAULT,
    ENTITY_STATE_EXPLODING,
    ENTITY_STATE_CHARRED,
    EVENT_INGAME_EXPLOSION,
    BALL_TYPE_BOMB,
    EVENT_INGAME_HURRY_UP,
    EVENT_INGAME_PLAYER_HITS_BALL,
    EVENT_INGAME_BALL_HITS_GROUND,
    GAMETYPE_BEST_OF,
    EVENTS_INGAME,
    EVENT_INGAME_TUTORIAL_FINISHED,
    EVENT_ENGINE_PRE_STOP,
    EVENT_ENGINE_POST_START,
    EVENT_INGAME_MATCHBALL,
    EVENT_INGAME_NEXT_ROUND,
    EVENT_INGAME_FINISHED,
    FIXED_FRAME_RATE,
    NO_PLAYER,
    PLAYER_1,
    PLAYER_2,
    LOGIC_GAME_INTRO,
    LOGIC_GAME_KICKOFF,
    LOGIC_GAME_FINISHED,
    EVENT_INGAME_SCORE_UPDATED,
    EVENT_INGAME_PLAYER_HITS_BALL_MAXIMUM,
    EVENT_GAME_PAUSE,
    EVENT_GAME_RESET,
    LOGIC_GAME_RUNNING,
    EVENT_INGAME_KICKOFF,
    EVENT_GAME_RESUME
} from "../global";

export class GameTypeLogic {
    /**
     * @param {Engine} engine
     */
    constructor(engine) {
        this.engine = engine;
    }

    /**
     * @param state
     */
    update(state) {
        // Inc time and dec contact delay
        if (!state.paused && state.logic == LOGIC_GAME_RUNNING && state.tutorial == undefined) {
            // Inc time
            state.time += state.timeDirection * FIXED_FRAME_RATE;

            // Dec contact delay
            if (state.contactDelay > 0) {
                state.contactDelay--;
            }
        }

        // Inc kickoff watch
        if (!state.paused && state.logic == LOGIC_GAME_KICKOFF) {
            state.kickoffWatch += FIXED_FRAME_RATE;
        }
    }

    /**
     * @param state
     */
    onReset(state) {
        state.logic = LOGIC_GAME_INTRO;
        state.time = 0;
        state.turn = PLAYER_1;
        state.player1.score = 0;
        state.player2.score = 0;
        state.player1.matches = 0;
        state.player2.matches = 0;
        state.won = NO_PLAYER;
        state.trophies = undefined;
        state.showTrophy = 0;
        state.hurried = false;
        this.resetPlayersAndBall(state);
        this.engine.fireEvent(EVENT_INGAME_SCORE_UPDATED);
    }

    /**
     * @param state
     */
    onPause(state) {}

    /**
     * @param state
     */
    onResume(state) {}

    /**
     * @param state
     */
    onPlayerHitsBall(state) {
        if (state.logic == LOGIC_GAME_KICKOFF) {
            state.logic = LOGIC_GAME_RUNNING;
        }

        if (state.logic == LOGIC_GAME_RUNNING) {
            if (state.contactDelay == 0) {
                if (state.lastContact == PLAYER_1) {
                    state.player1.contactCount++;
                    state.player2.contactCount = 0;
                } else if (state.lastContact == PLAYER_2) {
                    state.player1.contactCount = 0;
                    state.player2.contactCount++;
                }

                state.contactDelay = 5;
            }

            if (state.player1.contactCount > state.maxContacts || state.player2.contactCount > state.maxContacts) {
                this.engine.fireEvent(EVENT_INGAME_PLAYER_HITS_BALL_MAXIMUM);
            }
        }
    }

    /**
     * @param state
     */
    onPlayerHitsBallMaximum(state) {
        this.onBallHitsGround(state);
    }

    /**
     * @param state
     */
    onBallHitsGround(state) {}

    /**
     * @param state
     */
    onNextRound(state) {}

    /**
     * @param state
     */
    onKickoff(state) {
        // Reset kickoff watch
        state.kickoffWatch = 0;
    }

    /**
     * @param state
     */
    onFinished(state) {
        // Set state
        state.logic = LOGIC_GAME_FINISHED;

        // XXX Update trophies and save to state
        // TrophyService trophyService = (TrophyService) this.engine.getService(TrophyService.class);
        // state.trophies = trophyService.updateTrophies(this.engine.getContext(), this.engine.getState());

        // Set "show trophy"
        if (state.trophies != undefined && state.trophies.length > 0) {
            state.showTrophy = state.trophies.length;
            this.engine.fireEvent(EVENT_INGAME_TROPHY_ACHIEVED);
        } else {
            state.showTrophy = 0;
        }
    }

    /**
     * finishGame
     * @returns
     */
    finishGame(state, playerWon) {
        state.won = playerWon;
        state.logic = LOGIC_GAME_POST;
        this.engine.fireEvent(EVENT_INGAME_FINISHED, 2000);
    }

    /**
     * resetPlayersAndBall
     * @param state
     */
    resetPlayersAndBall(state) {
        state.lastContact = NO_PLAYER;
        state.contactDelay = 0;
        state.player1.position.set(state.player1Start);
        state.player1.velocity.zero();
        state.player1.motion.zero();
        state.player1.target = undefined;
        state.player1.contactCount = 0;
        state.player2.position.set(state.player2Start);
        state.player2.velocity.zero();
        state.player2.motion.zero();
        state.player2.target = undefined;
        state.player2.contactCount = 0;
        state.ball.position.set(state.turn == PLAYER_1 ? state.ballForPlayer1Start : state.ballForPlayer2Start);
        state.ball.velocity.zero();
    }
}

export class GameTypeLogicTutorial extends GameTypeLogic {}

export class GameTypeLogicBestOf5 extends GameTypeLogic {
    /**
     * onBallHitsGround
     * @param state
     */
    onBallHitsGround(state) {
        if (state.logic != LOGIC_GAME_RUNNING) {
            return;
        }

        state.logic = LOGIC_GAME_POST;
        this.applyPoints(state);

        if (state.player1.score >= 3) {
            state.player1.score = 0;
            state.player2.score = 0;
            state.player1.matches++;
        } else if (state.player2.score >= 3) {
            state.player1.score = 0;
            state.player2.score = 0;
            state.player2.matches++;
        }

        this.engine.fireEvent(EVENT_INGAME_SCORE_UPDATED);
        if (state.player1.matches == 3 || state.player2.matches == 3) {
            this.finishGame(state, state.player1.matches > state.player2.matches ? PLAYER_1 : PLAYER_2);
        } else {
            this.engine.fireEvent(EVENT_INGAME_NEXT_ROUND, 1500);
        }
    }

    /**
     * onNextRound
     * @param state
     */
    onNextRound(state) {
        this.engine.fireEvent(EVENT_INGAME_KICKOFF);
        state.turn = ++state.turn % 2;
        this.resetPlayersAndBall(state);

        // Matchpoint?
        if ((state.player1.matches == 2 && state.player1.score == 2) || (state.player2.matches == 2 && state.player2.score == 2)) {
            this.engine.fireEvent(EVENT_INGAME_MATCHBALL);
        }
    }

    /**
     * applyPoints
     * @param state
     */
    applyPoints(state) {
        var field = state.ball.position.x < 0 ? PLAYER_1 : PLAYER_2;
        if (field != state.lastContact) {
            if (state.lastContact == PLAYER_1) {
                state.player1.score++;
            } else {
                state.player2.score++;
            }
        } else {
            if (state.lastContact == PLAYER_1) {
                state.player2.score++;
            } else {
                state.player1.score++;
            }
        }
    }
}

var GAMELOGIC_BOMB_MAX_SCORE = 10;

export class GameTypeLogicBomb extends GameTypeLogicBestOf5 {
    update(state) {
        // Super
        super.update(state);

        // Update bomb explosion animation
        if (state.ball.fuse <= 0) {
            state.ball.animExplosion += 1;
        }

        // Break if game is not running
        if (state.logic != LOGIC_GAME_RUNNING || state.paused) {
            return;
        }

        // Fire "hurry up!"
        if (!state.hurried && state.ball.fuse < 0.25) {
            state.hurried = true;
            this.engine.fireEvent(EVENT_INGAME_HURRY_UP);
        }

        // Ball exploded?
        if (state.ball.fuse > 0) {
            state.ball.fuse -= Math.random() > 0.1 ? 0.005 : 0.001;
        } else {
            this.calcScore(state, true);
        }
    }

    onReset(state) {
        // Super
        super.onReset(state);

        // Reset state
        this.resetState(state);
    }

    onNextRound(state) {
        // Super
        super.onNextRound(state);

        // Reset state
        if (state.ball.fuse <= 0) {
            this.resetState(state);
        }

        // Matchball?
        if (state.player1.score >= GAMELOGIC_BOMB_MAX_SCORE - 1 || state.player2.score >= GAMELOGIC_BOMB_MAX_SCORE - 1) {
            this.engine.fireEvent(EVENT_INGAME_MATCHBALL);
        }
    }

    onBallHitsGround(state) {
        // Break if game is not running
        if (state.logic != LOGIC_GAME_RUNNING) {
            return;
        }

        // Set state
        this.calcScore(state, true);
    }

    onPlayerHitsBallMaximum(state) {
        // Break if game is not running
        if (state.logic != LOGIC_GAME_RUNNING) {
            return;
        }

        // Set state
        this.calcScore(state, false);
    }

    calcScore(state, explode) {
        // Explode bomb
        if (explode) {
            state.ball.sticky = true;
            state.ball.state = ENTITY_STATE_EXPLODING;
            state.ball.fuse = 0;
            this.engine.fireEvent(EVENT_INGAME_EXPLOSION);
        }

        // Estimate game logic
        if (state.ball.position.x < 0) {
            state.player2.score++;
            if (explode) {
                state.player1.state = ENTITY_STATE_CHARRED;
                state.explosionMark = state.ball.position.x;
            }
        } else {
            state.player1.score++;
            if (explode) {
                state.player2.state = ENTITY_STATE_CHARRED;
                state.explosionMark = state.ball.position.x;
            }
        }

        // Estimate game logic
        this.engine.fireEvent(EVENT_INGAME_SCORE_UPDATED);
        if (state.player1.score == GAMELOGIC_BOMB_MAX_SCORE || state.player2.score == GAMELOGIC_BOMB_MAX_SCORE) {
            this.finishGame(state, state.player1.score > state.player2.score ? PLAYER_1 : PLAYER_2);
        } else {
            state.logic = LOGIC_GAME_POST;
            this.engine.fireEvent(EVENT_INGAME_NEXT_ROUND, 3000);
        }
    }

    /**
     * @param state
     */
    resetState(state) {
        state.hurried = false;
        state.ball.fuse = 1;
        state.ball.sticky = false;
        state.ball.animExplosion = 0;
        state.ball.type = BALL_TYPE_BOMB;
        state.ball.state = ENTITY_STATE_DEFAULT;
        state.player1.state = ENTITY_STATE_DEFAULT;
        state.player2.state = ENTITY_STATE_DEFAULT;
        state.explosionMark = 0;
    }
}

export class GameTypeLogicTime extends GameTypeLogicBestOf5 {
    update(state) {
        // Super
        super.update(state);

        // Break if game is not running
        if (state.logic != LOGIC_GAME_RUNNING || state.paused) {
            return;
        }

        // Fire "hurry up!"
        if (!state.hurried && state.time < 4000) {
            state.hurried = true;
            this.engine.fireEvent(EVENT_INGAME_HURRY_UP);
        }

        // Time ellapsed?
        if (state.time <= 0 && state.timeDirection != 0) {
            // Reset timing
            state.time = 0;
            state.timeDirection = 0;

            // Estimate game logic
            if (state.player1.score != state.player2.score) {
                this.engine.fireEvent(EVENT_INGAME_SCORE_UPDATED);
                this.finishGame(state, state.player1.score > state.player2.score ? PLAYER_1 : PLAYER_2);
            }
        }
    }

    onReset(state) {
        // Super
        super.onReset(state);

        // Overwrite time settings
        state.time = 60 * 1000;
        state.timeDirection = -1;
    }

    onBallHitsGround(state) {
        // Break if game is not running
        if (state.logic != LOGIC_GAME_RUNNING) {
            return;
        }

        // Set state
        state.logic = LOGIC_GAME_POST;

        // Apply points
        this.applyPoints(state);

        // Estimate game logic
        this.engine.fireEvent(EVENT_INGAME_SCORE_UPDATED);
        if (state.time <= 0) {
            this.finishGame(state, state.player1.score > state.player2.score ? PLAYER_1 : PLAYER_2);
        } else {
            this.engine.fireEvent(EVENT_INGAME_NEXT_ROUND, 1500);
        }
    }
}

/**
 * Game Logic
 */
export class GameLogic extends Component {
    init() {
        //
        this.state.f = 0;

        // Create tutorial game logic
        this.gameTypeLogicTutorial = new GameTypeLogicTutorial(this.engine);

        // Create game logic
        switch (this.state.type) {
            case GAMETYPE_TIME:
                this.gameTypeLogicCurrent = new GameTypeLogicTime(this.engine);
                break;
            case GAMETYPE_BOMB:
                this.gameTypeLogicCurrent = new GameTypeLogicBomb(this.engine);
                break;
            case GAMETYPE_BEST_OF:
                this.gameTypeLogicCurrent = new GameTypeLogicBestOf5(this.engine);
                break;
        }

        // Check
        if (this.gameTypeLogicCurrent == undefined) {
            throw "No game type specified";
        }

        // Set current game logic
        if (this.state.tutorial == undefined) {
            this.gameLogic = this.gameTypeLogicCurrent;
        } else {
            this.gameLogic = this.gameTypeLogicTutorial;
        }
    }

    update() {
        this.state.f += 1;
        // this.state.camera.x = (Math.sin((this.state.f++) / 50) * 30);

        if (this.gameLogic != undefined) {
            this.gameLogic.update(this.state);
        }
    }

    handleEvent(event) {
        // Init state
        var state = this.state;

        //
        switch (event.type) {
            case EVENT_ENGINE_POST_START:
                if (state.logic != 0) {
                    break;
                }
            case EVENT_GAME_RESET:
                this.gameLogic.onReset(state);
                this.engine.clearEvents(EVENTS_INGAME);
                this.engine.disableEventFilter(EVENTS_INGAME);
                break;
            case EVENT_ENGINE_PRE_STOP:
            case EVENT_GAME_PAUSE:
                if (!state.paused) {
                    state.paused = true;
                    this.engine.enableEventFilter(EVENTS_INGAME);
                    this.gameLogic.onPause(state);
                }

                break;
            case EVENT_GAME_RESUME:
                if (state.paused) {
                    state.paused = false;
                    this.engine.disableEventFilter(EVENTS_INGAME);
                    this.gameLogic.onResume(state);
                }

                break;
            case EVENT_INGAME_KICKOFF:
                state.logic = LOGIC_GAME_KICKOFF;
                state.kickoffWatch = 0;
                this.gameLogic.onKickoff(state);
                break;
            case EVENT_INGAME_PLAYER_HITS_BALL:
                this.gameLogic.onPlayerHitsBall(state);
                break;
            case EVENT_INGAME_PLAYER_HITS_BALL_MAXIMUM:
                this.gameLogic.onPlayerHitsBallMaximum(state);
                break;
            case EVENT_INGAME_BALL_HITS_GROUND:
                this.gameLogic.onBallHitsGround(state);
                break;
            case EVENT_INGAME_NEXT_ROUND:
                this.gameLogic.onNextRound(state);
                break;
            case EVENT_INGAME_TUTORIAL_FINISHED:
                this.gameLogic = this.gameTypeLogicCurrent;
                this.engine.fireEvent(EVENT_GAME_RESET);
                break;
            case EVENT_INGAME_FINISHED:
                this.gameLogic.onFinished(state);
                break;
        }
    }
}
